module.exports = __webpack_public_path__ + "static/media/logo-leaf-white.6138f323.svg";